"use client";
import getPublicClient from "@/lib/algolia/getPublicClient";
import { InstantSearch } from "react-instantsearch";
import { SearchProps } from "@/components/Search/types";
import { PRODUCT_SUMMARY_INDEX_EN } from "@/constants/algolia";
import useSearchInitialState from "./hooks/useSearchInitialState";
import { SearchContextProvider } from "./components/SearchContextProvider";
import SearchContent from "./components/SearchContent";

const searchClient = getPublicClient();

function Search(props: SearchProps) {
  const initialSearchState = useSearchInitialState(
    PRODUCT_SUMMARY_INDEX_EN,
    props.query_string,
  );

  return (
    <SearchContextProvider searchIndex={PRODUCT_SUMMARY_INDEX_EN}>
      <InstantSearch
        searchClient={searchClient}
        indexName={PRODUCT_SUMMARY_INDEX_EN}
        initialUiState={initialSearchState}
        future={{
          preserveSharedStateOnUnmount: true,
        }}
      >
        <SearchContent {...props} />
      </InstantSearch>
    </SearchContextProvider>
  );
}

export default Search;
